// @ts-check
import { nextArrow, prevArrow, options } from "@/global/slick-options";
import { getAll } from "@/utilities/querySelector";

jQuery( function( $ ) {
    const sliders = getAll( '[data-card-slider]' );
    if ( sliders.length ) {
        sliders.forEach( ( slider ) => {
            const size = slider.getAttribute( "data-card-slider-size" );
            const additionalOptions = JSON.parse( slider.getAttribute( 'data-slider-options' ) ?? '{}' );

            let customOptions = {};
            let defaultOptions = {
                ...options,
                nextArrow,
                prevArrow
            };

            if ( size === "small" ) {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 4,
                    responsive: [
                        {
                            breakpoint: 1320,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 980,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ],
                };
            } else if ( size == "medium" ) {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 2.33,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 850,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                    ],
                };
            } else if ( size == "large" ) {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 1 + 1/3,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                    ],
                };
            } else if ( size == "huge" ) {
                customOptions = {
                    ...defaultOptions,
                    slidesToShow: 1,
                };
            }

            $( slider ).slick( {
                ...customOptions,
                ...additionalOptions
            } );
        } );
    }
} );
